import React, { useState } from "react";
import FieldInput from "../../../../components/ModuleCommon/FormBuilder/FieldInput";
import FieldDropdown from "../../../../components/ModuleCommon/FormBuilder/FieldDropdown";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";

const facilityTypes = [
  { value: "TERMINAL", label: "Terminal" },
  { value: "WAREHOUSE", label: "Warehouse" },
  { value: "PORT", label: "Port" },
];

const FormLane = ({ contractCode, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    laneCode: "",
    name: "",
    description: "",
    origin: "",
    destination: "",
    viaPoint: "",
    viaPoint2: "",
    viaPoint3: "",
    originType: "TERMINAL",
    destinationType: "TERMINAL",
  });

  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
    const errors = {};
    if (!formData.laneCode.trim()) errors.laneCode = "Lane Code is required";
    if (!formData.origin.trim()) errors.origin = "Origin is required";
    if (!formData.destination.trim())
      errors.destination = "Destination is required";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // 这里通常会有API调用
    onSuccess(formData.laneCode);
  };

  const handleChange = (id, value) => {
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));

    // 清除对应字段的验证错误
    if (validationErrors[id]) {
      setValidationErrors((prev) => ({
        ...prev,
        [id]: undefined,
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="space-y-4">
        {/* Contract Info */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contract Code
            </label>
            <FieldInput
              type="text"
              value={contractCode}
              disabled
              className="w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Lane Code<span className="text-red-600">*</span>
            </label>
            <FieldInput
              type="text"
              value={formData.laneCode}
              onChange={(val) => handleChange("laneCode", val)}
              required
              className="w-full"
              error={validationErrors.laneCode}
            />
          </div>
        </div>

        {/* Origin & Destination */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Origin<span className="text-red-600">*</span>
            </label>
            <FieldInput
              type="text"
              value={formData.origin}
              onChange={(val) => handleChange("origin", val)}
              required
              className="w-full"
              error={validationErrors.origin}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Destination<span className="text-red-600">*</span>
            </label>
            <FieldInput
              type="text"
              value={formData.destination}
              onChange={(val) => handleChange("destination", val)}
              required
              className="w-full"
              error={validationErrors.destination}
            />
          </div>
        </div>

        {/* Facility Types */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Origin Facility Type<span className="text-red-600">*</span>
            </label>
            <FieldDropdown
              value={formData.originType}
              options={facilityTypes}
              onChange={(val) => handleChange("originType", val)}
              className="w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Destination Facility Type<span className="text-red-600">*</span>
            </label>
            <FieldDropdown
              value={formData.destinationType}
              options={facilityTypes}
              onChange={(val) => handleChange("destinationType", val)}
              className="w-full"
            />
          </div>
        </div>

        {/* Via Points */}
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map((num) => (
            <div key={num}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {`Via Point ${num > 1 ? num : ""}`}
              </label>
              <FieldInput
                type="text"
                value={formData[`viaPoint${num > 1 ? num : ""}`]}
                onChange={(val) =>
                  handleChange(`viaPoint${num > 1 ? num : ""}`, val)
                }
                className="w-full"
              />
            </div>
          ))}
        </div>

        {/* Additional Fields */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Lane Name
            </label>
            <FieldInput
              type="text"
              value={formData.name}
              onChange={(val) => handleChange("name", val)}
              className="w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description
            </label>
            <FieldInput
              type="textarea"
              value={formData.description}
              onChange={(val) => handleChange("description", val)}
              className="w-full"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 mt-6">
          <Button
            type="button"
            text="Cancel"
            variant="outline"
            onClick={onCancel}
          />
          <Button
            type="submit"
            text="Save Lane"
            variant="primary"
            onSubmit={handleSubmit}
            />
        </div>
      </div>
    </form>
  );
};

export default FormLane;
